<template>
  <div class="allStore">
    <!-- 顶部tab卡 -->
    <div class="topTab" style="position: fixed;">
      <!-- 智能排序 -->
      <span @click="openSortMark()" :class="[sort ? 'active': '', 'tabNeo']">{{sortTitle}}
        <img v-if="sort" style="transform:rotate(180deg);" src="../../assets/images/square3up.png" alt="">
        <img v-else src="../../assets/images/square3down.png" alt="">
      </span>
      <!-- 门店筛选 -->
      <span @click="openScreenMark()" :class="[screen ? 'active': '', 'tabNeo']">门店筛选
        <img v-if="screen" style="transform:rotate(180deg);" src="../../assets/images/square3up.png" alt="">
        <img v-else src="../../assets/images/square3down.png" alt="">
      </span>
    </div>
    <!-- 门店列表 -->
    <div class="storeCard" v-for="(item, index) in show_sotre" :key="index" @click="likeThis(item, item.id)">
      <div class="sign">{{item.coop_title}}</div>
      <img class="storeLogo" :src="item.image" alt="">
      <div class="storeInfo">
        <div class="storeName">{{item.title}}</div>
        <div class="storePhone">联系方式：{{item.phone}}</div>
        <div class="storeAddress">
          <span class="storeAddressAddress">{{item.address}}</span>
          <span class="storeAddresDistance"></span>
        </div>
        <div style="display: flex;">
          <span class="storeTag" style="background-color: #f2430c;color: #fff;">{{item.service_title}}</span>
          <span class="storeTag">{{item.door_title}}</span>
          <span class="storeTag" v-for="(t, i) in item.tag" :key="i">{{t}}</span>
        </div>
      </div>
      <div class="locationBox" @click="call(item.phone)"><img class="location" src="../../assets/images/call.png" alt=""></div>
      <div class="locationBox" @click="watchMap(item)"><img class="location" src="../../assets/images/bluelocation.png" alt=""></div>
      <div class="chose" v-if="default_index == item.id">
        <img class="location" src="../../assets/images/select.png" alt="">
      </div>
    </div>
    <!-- 点击加载更多 -->
    <div class="moreStore" v-if="show_sotre.length >= 10 && !empty && !noMore" @click="moreStore">点击加载更多</div>
    <div class="moreStore" v-if="noMore">没有更多了</div>
    <!-- 占位div -->
    <div style="height: 1rem;"></div>
    <!-- 底部确认框 -->
    <div class="pageBottom">
      <div class="cancel" @click="cancel">取消</div>
      <div class="confirm" @click="confirm">确定</div>
    </div>

    <div class="empty" v-if="empty">
      <img src="../../assets/images/empty.png" alt="">
      <div>没有符合要求的门店呢</div>
    </div>



    <!-- 点击选项卡弹出的遮罩 -->
    <div class="tabMark" :style="{'top': openMarkSign ? '1rem' : '-100rem'}" @click="clickMark"></div>
    <!-- 智能排序的选项列表 -->
    <div :class="['sortMark', sort ? 'showSort': 'hide']">
      <div @click="choseThis('智能排序', 1)" :class="[sortChoseThis == 1 ? 'sortChose': '']">智能排序</div>
      <div @click="choseThis('距离最近', 2)" :class="[sortChoseThis == 2 ? 'sortChose': '']">距离最近</div>
    </div>
    <!-- 门店筛选的选项列表 -->
    <div :class="['screenMark', screen ? 'showScreen':'hide']">
      <!-- 筛选框的标题 -->
      <div class="screenMarkTitle">
        合作类型
      </div>
      <!-- 选项 -->
      <div class="tagBox">
        <div class="tag" v-for="(item, index) in coop_type" :key="index" @click="clickTagsDoor_type(item.id, item, $event)">{{item.name}}</div>
      </div>
      <!-- 筛选框的标题 -->
      <div class="screenMarkTitle">
        门店服务
      </div>
      <!-- 选项 -->
      <div class="tagBox">
        <div class="tag" v-for="(item, index) in service" :key="index" @click="clickTagsService(item.id, item, $event)">{{item.name}}</div>
      </div>
      <!-- 筛选框的标题 -->
      <div class="screenMarkTitle">
        门店类型
      </div>
      <!-- 选项 -->
      <div class="tagBox">
        <div class="tag" v-for="(item, index) in door_type" :key="index" @click="clickTagsCoop_type(item.id, item, $event)">{{item.name}}</div>
      </div>
      <!-- 底部div -->
      <!-- <div style="height: 0.75rem"></div> -->
      <!-- 按钮 -->
      <div class="btnBox">
        <div class="btn btn1" @click="reset">重置</div>
        <div class="btn btn2" @click="screenSomething">确定</div>
      </div>
    </div>

  </div>
</template>

<script>
var _mine
var geolocation = new qq.maps.Geolocation("SP7BZ-MXV6Q-LZY5O-GVGI3-II2C7-PNFFP", "智强app");
import { getAllStore, getThoseStore } from "../../api/order";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      // 是否打开排序框
      sort: false,
      // 是否打开筛选框
      screen: false,
      // 是否打开遮罩
      openMarkSign: false,
      // 选中了那个排序方式，默认为第一个智能排序
      sortChoseThis: 1,
      // 选中的排序方式名称，默认为智能排序
      sortTitle: '智能排序',
      // 门店类型
      door_type: {},
      // 合作类型
      coop_type: {},
      // 全部门店
      all_store: [],
      // 展示出来的门店，经过筛选之类的
      show_sotre: [],
      // 服务类型
      service: {},
      // 默认选中的门店
      default_index: null,
      // 选中的筛选条件
      activeDoor_type: {},
      activeCoop_type: {},
      activeService: {},
      // 自身的定位
      latitude: '',
      longitude: '',
      // 选中门店的定位
      activePosition: {
        latitude: '',
        longitude: ''
      },
      mapShow: false,
      // 选中了哪个门店
      choseStore: {},
      // 是否有数据
      empty: false,
      formData: {
        lat: '',
        lng: '',
        door_type: '',
        coop_type: '',
        service: '',
        page: 1
      },
      // 是否还有更多门店
      noMore: false
    }
  },
  methods: {
    moreStore(){
      this.formData.page = this.formData.page + 1
      // 获取数据
      getAllStore(this.formData).then(res => {
        const { data: val } = res.data
        if(!val[0]){
          this.noMore = true
        }else{
          this.noMore = false
        }
        this.show_sotre = this.show_sotre.concat(val)
       
      }).catch(err => {
        console.log(err)
      })
    },
    // 页面底部的取消
    cancel(){
      this.$router.go(-1);
    },
    // 页面底部的确定
    confirm(){
      _mine.$store.commit('DEFAULT_STORE', this.choseStore)
      window.sessionStorage.setItem('index', this.default_index)
      this.$router.go(-1);
    },
    // 点击哪个就选中那个门店
    likeThis(item, index) {
      this.default_index = index
      this.choseStore = item
    },
    // 点击小电话图标
    call(phone) {
      window.location.href = "tel:" + phone
    },
    clickMark() {
      return false
    },
    // 打开地图
    watchMap(item){
      this.activePosition.latitude = item.lag
      this.activePosition.longitude = item.log
      // this.mapShow = true
      this.$router.push({
        path: '/door/map',
        query: {
          latitude: item.lag,
          longitude: item.log
        }
      })
    },
    // 获取定位
    getLocation(){
      geolocation.getLocation((position)=>{
        // 纬度
        this.longitude = position.lng
        // 经度
        this.latitude = position.lat
      })
    },
    // 确认筛选
    screenSomething() {

      this.openMarkSign = false

      this.sort = false

      this.screen = false

      const obj1 = this.activeCoop_type

      const obj2 = this.activeDoor_type

      const obj3 = this.activeService

      const arr1 = Object.values(obj1)

      const arr2 = Object.values(obj2)

      const arr3 = Object.values(obj3)

      let str1 = '', str2 = '', str3 = ''
      
      for (let index = 0; index < arr1.length; index++) {

          str1 += `${arr1[index].id},`

      }
      for (let index = 0; index < arr2.length; index++) {

          str2 += `${arr2[index].id},`

      }
      for (let index = 0; index < arr3.length; index++) {

          str3 += `${arr3[index].id},`

      }
      
      str1 = str1.substring(0, str1.length-1)
      str2 = str2.substring(0, str2.length-1)
      str3 = str3.substring(0, str3.length-1)


      if(str1) {
        this.formData.coop_type = str1
      }else{
        this.formData.coop_type = ''
      }
      if(str2) {
        this.formData.door_type = str2
      }else{
        this.formData.door_type = ''
      }
      if(str3) {
        this.formData.service = str3
      }else{
        this.formData.service = ''
      }

      this.formData.page = 1
      
      // 获取数据
      getAllStore(this.formData).then(res => {
        const { data: val } = res.data
        this.show_sotre = val
        if (!val[0]){
          this.empty = true
          this.noMore = false
        }else{
          this.empty = false
        }
      }).catch(err => {
        console.log(err)
      })


    },
    // 重置所有标签的选中态
    reset() {
      this.activeCoop_type = {}
      this.activeService = {}
      this.activeDoor_type = {}
      let tags = document.getElementsByClassName('tag')
      for (let i = 0 ; i < tags.length; i ++) {
        tags[i].className = 'tag'
      }
      this.formData.coop_type = ''
      this.formData.door_type = ''
      this.formData.service = ''
      this.formData.page = 1
      this.openMarkSign = false
      this.sort = false
      this.screen = false
      // 获取数据
      getAllStore(this.formData).then(res => {
        const { data: val } = res.data
        this.show_sotre = val
        if (!val[0]){
          this.empty = true
          this.noMore = false
        }else{
          this.empty = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 选择tag
    clickTagsDoor_type(id, data, event){
      // 判断当前点击的tag有没有被选中
      const val = event.target.getAttribute('class').includes('activeTag')
      if (val) {
      // 被选中的tag，被点击时删除存储的id，并清除样式
        delete this.activeCoop_type[id]
        event.target.className = 'tag'
      }else{
      // 未被选中的tag，被点击时存储id，并添加样式
        this.activeCoop_type[id] = data
        event.target.className = 'tag activeTag'
      }
    },
    // 选择tag
    clickTagsCoop_type(id, data, event){
      // 判断当前点击的tag有没有被选中
      const val = event.target.getAttribute('class').includes('activeTag')
      if (val) {
      // 被选中的tag，被点击时删除存储的id，并清除样式
        delete this.activeDoor_type[id]
        event.target.className = 'tag'
      }else{
      // 未被选中的tag，被点击时存储id，并添加样式
        this.activeDoor_type[id] = data
        event.target.className = 'tag activeTag'
      }
    },
    // 选择tag
    clickTagsService(id, data, event){
      // 判断当前点击的tag有没有被选中
      const val = event.target.getAttribute('class').includes('activeTag')
      if (val) {
      // 被选中的tag，被点击时删除存储的id，并清除样式
        delete this.activeService[id]
        event.target.className = 'tag'
      }else{
      // 未被选中的tag，被点击时存储id，并添加样式
        this.activeService[id] = data
        event.target.className = 'tag activeTag'
      }
      console.log(this.activeService);
    },
    // 获取全部门店
    getStore() {
      console.log(1);
      getAllStore().then(res => {
        const { data } = res
        _mine.coop_type = data.coop_type
        _mine.door_type = data.doo_type
        _mine.all_store = data.data
        _mine.show_sotre = data.data
        _mine.service = data.service
      }).catch(err => {
        console.log(err);
      })
    },
    // 打开排序遮罩
    openSortMark (index) {
      // 先打开背景遮罩
      this.openMarkSign = true
      if (!this.sort){
        this.sort = true
        this.screen = false
      }else{
        this.openMarkSign = false
        this.sort = false
        this.screen = false
      }
      // 打开排序tab选项
    },
    // 打开筛选遮罩
    openScreenMark () {
      this.openMarkSign = true
      if (!this.screen){
        this.sort = false
        this.screen = true
      }else{
        this.openMarkSign = false
        this.sort = false
        this.screen = false
      }
    },
    // 选择了排序方式
    choseThis(title, index){
      // 关闭遮罩
      this.openMarkSign = false
      // 关闭排序框
      this.sort = false
      // 设置显示的标题
      this.sortTitle = title
      // 设置排序方式的选中态
      this.sortChoseThis = index
      if(index == 1) {
        this.formData.lat = ''
        this.formData.lng = ''
      }else{
        this.formData.lat = this.latitude
        this.formData.lng = this.longitude 
      }
        this.formData.page = 1
      // 获取数据
        getAllStore(this.formData).then(res => {
          const { data: val } = res.data
          this.show_sotre = val
          if (!val[0]){
            this.empty = true
            this.noMore = false
          }else{
            this.empty = false
          }
        }).catch(err => {
          console.log(err)
        })
    }
  },
  mounted() {
    _mine = this

    const id = this.$route.query.id
    
    if (id){
      this.default_index = id
    }
    console.log(1);
    this.getStore()
    this.getLocation()
  }
};
</script>

<style scoped>
.sign{
  position: absolute;
  top: 8px;
  left: 15px;
  padding: 1px 5px;
  background-color: #f2430c;
  color: #fff;
  font-size: 10px;
  border-radius: 8px 8px 8px 0;
}
.moreStore{
  width: 100%;
  height: 26px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
.empty{
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.empty img{
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.5rem;
}
.pageBottom{
  height: 1rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
}
.pageBottom div{
  width: 50%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}
.cancel{
  background-color: #fdfdfd;
}
.confirm{
  background-color: #e93323;
  color: #fff;
}
.chose{
  position: absolute;
  right: 20px;
  top: 20px;
}
.allStore{
  padding-top: 1rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 99;
}
.topTab{
  display: flex;
  justify-content: center;
  height: 1rem;
  line-height: 1rem;
  background-color: #fff;
  font-size: 13px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
}
.topTab span{
  width: 50%;
  text-align: center;
}
.topTab img{
  width: 10px;
  height: 10px;
  margin-left: 2px;
}
.tabNeo{
  color: #999;
}
.active{
  color: #e93323;
}
.tabMark{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .2);
  position: fixed;
  top: -100rem;
  left: 0;
}
.hide{
  display: none;
}
.sortMark,
.screenMark{
  background-color: #f7f7f9;
  width: 100%;
  position: fixed;
  top: 1rem;
  left: 0;
  z-index: 2;
  border-radius: 0 0 0.2rem 0.2rem;
  overflow: hidden;
}
.screenMarkTitle{
  height: 1rem;
  line-height: 1rem;
}
.screenMark div{
  padding: 0 0.3rem;
}
.sortMark div{
  padding-left: 0.3rem;
  height: 0.75rem;
  line-height: 0.75rem;
  font-size: 13px;
}
.showSort,
.showScreen{
  display: block;
}
.sortChose{
  color: #e93323;
}
/* .screenMark{
  height: 6.5rem;
  overflow: scroll;
} */
.tagBox{
  display: flex;
  flex-wrap: wrap;
}
.tag{
  padding: 5px 10px!important;
  background-color: #F2F2F2;
  color: #333;
  border-radius: 10px;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  border: 1px solid transparent;
}
.btnBox{
  display: flex;
  /* position: fixed; */
  /* top: 3.5rem; */
  /* bottom: 0; */
  /* left: 0; */
  height: 1rem;
  line-height: 1rem;
  width: 100%;
  background-color: plum;
  padding: 0!important;
  border-radius: 0 0 0.2rem 0.2rem;
  overflow: hidden;
  z-index: 999999;
}
.btn{
  width: 50%;
  height: 100%;
  text-align: center;
}
.btn1{
  background-color: #f2f2f2;
  color: #8c8c8c;
}
.btn2{
  background-image: linear-gradient(135deg,#f2140c 0%,#f2270c 70%,#f24d0c 100%);
  color: #ffffff;
}
.activeTag{
  border: 1px solid #e93323!important;
  color: #e93323;
}
.storeCard{
  width: 100%;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
  margin: 10px 0;
  padding: 15px 15px 10px;
  display: flex;
  align-items: center;
  position: relative;
}
.storeLogo{
  width: 1.5rem;
  height: 1.5rem;
}
.storeInfo{
  margin-left: 10px;
  flex: 1;
}
.storeName{
  font-size: 16px;
  font-weight: bold;
}
.storePhone{
  font-size: 10px;
  color: #666;
  margin: 5px 0;
}
.storeAddress{
  font-size: 10px;
  color: #666;
  margin: 5px 0;
}
.storeTag{
  font-size: 11px;
  color: #e93323;
  border: 1px solid #e93323;
  padding: 1px 3px;
  border-radius: 5px;
  margin-right: 5px;
}
.storeAddressAddress{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
/* 　text-overflow: ellipsis; */
/* 　white-space: nowrap; */
}
.storeAddresDistance{

}
.locationBox{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  line-height: 30px;
  background-color: #f7f7f7;
  position: relative;
}
.location{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
}
</style>
